export const GET_SURVEYS = "GET_SURVEYS";
export const GET_SURVEY_BY_ID = "GET_SURVEY_BY_ID";
export const UPDATE_SURVEY = "UPDATE_SURVEY";
export const DELETE_SURVEY = "DELETE_SURVEY";
export const CREATE_SURVEY = "CREATE_SURVEY";
export const ANSWER_QUESTION = "ANSWER_QUESTION";
export const GET_PROFILE = "GET_PROFILE";
